/**
 * @fileoverview Main entry point for the Buurtbasis application.
 * Initializes all managers and components when the DOM is ready.
 * @module index
 */

// ============================================================================
// Stylescape Initialization
// ============================================================================
import { initializeStylescape } from "stylescape";
initializeStylescape();

// ============================================================================
// Canvas Background Handler
// ============================================================================

document.addEventListener("DOMContentLoaded", () => {
  const canvasEl = document.querySelector(".canvas");
  if (canvasEl) {
    const frameMain = document.querySelector<HTMLElement>(".frame_main");
    if (frameMain) {
      frameMain.style.background = "none";
    }
  }
});

// ============================================================================
// Import
// ============================================================================
import { DataTableManager, GraphManager } from '@starling-cloud/sturnia-graph';

// Sturnia plot/legend integration (shared across all KodW apps)
import './sturnia';
export * from './sturnia';

import { BuurtpeilingStudyFormManager } from './BuurtpeilingStudyFormManager';
import { ExportManager } from './ExportManager';


// ============================================================================
// Exported Functions
// ============================================================================

export function manageBuurtpeilingStudyForm(
    form_div_id: string,
    response_div_id: string,
    question_container_div_id: string,
) {
    document.addEventListener('DOMContentLoaded', () => {
        const buurtpeilingstudyformmanager = new BuurtpeilingStudyFormManager(
            form_div_id,
            response_div_id,
            question_container_div_id,
        )
    })
}

// ============================================================================
// Initialize Managers
// ============================================================================

const graphManager = new GraphManager()
const exportManager = new ExportManager()

document.addEventListener('DOMContentLoaded', () => {
    const dataTableManager = new DataTableManager('data_table')
})
